module.exports = __webpack_public_path__ + "img/EXTERIOR-S-CROSS-1.d8e5aa56.jpg";